import { BaseModel } from "@Core";
import { PermitExempt } from "./PermitExempt";

export interface VehicleExempt extends BaseModel {
    PermitExemptId?: number;
    Plate: string;
    VehicleExemptTag?: VehicleExemptTag;
    PermitExempt?: PermitExempt;
}

export enum VehicleExemptTag {
    EmergencyVehicle = 'Emergency vehicle',
    Bus = 'Bus',
    Taxi = 'Taxi',
    BinLorriesRefuse = 'Bin lorries/Refuse',
    HGVS = 'HGVS',
    BreakdownVehicle = 'Breakdown vehicle',
    ClientRequest = 'Client request'
}
